import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-font-size-manager',
  templateUrl: './font-size-manager.component.html',
  styleUrl: './font-size-manager.component.scss',
})
export class FontSizeManagerComponent {
  @Input()
  fontSize: number = 0.875;

  fontSizes: Map<number, string> = new Map([
    [0.625, 'XXS'],
    [0.75, 'XS'],
    [0.875, 'S'],
    [1, 'M'],
    [1.125, 'L'],
    [1.25, 'XL'],
  ]);

  fontSizeMap = (value: number): string => this.fontSizes.get(value) ?? 'S';

  @Output()
  fontSizeChange: EventEmitter<number> = new EventEmitter<number>();

  changeFontSize(fontSize: number) {
    this.fontSizeChange.emit(fontSize);
  }
}
